var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-title-item"},[_c('img',{staticClass:"game-title-item-img",attrs:{"src":_vm.img}}),_vm._v(" "),_c('div',{staticClass:"game-title-item-name"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"game-title-item-studio"},[_vm._v(_vm._s(_vm.company))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11e71a15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game-detail/GameTitle.vue
// module id = null
// module chunks = 